import React, { useEffect, useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import config from "../../config";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { triggerNotification } from "../message/Msg";

const TableViewer = ({
  rowData,
  colDefs,
  onEdit,
  onDelete,
  onExport,
  onView,
  onRowClicked,
  onStatusChange,
  onMcqView,
  onEnable,
  onDoubt,
  onResult,
  haveImage,
  showWithTwoPara,
  resultOf,
  onDuplicate,
  fromDraft,
  fetchDataAfterAction,
  tableTitle,
  btnTxtFor,
  btnTxtAction,
  actionUrl,
}) => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState(rowData);
  //-----------------for chapter multiple delete/ restore only----------------
  const token = config.token;
  const [list, setList] = useState();
  const [isBtnEnabled, setIsBtnEnabled] = useState(false);
  // ----------------------------------------------------------------

  const pagination = true;
  const paginationPageSize = 100;
  const paginationPageSizeSelector = [5, 10, 25, 50, 100];
  const { user_type } = config;

  useEffect(() => {
    // Filter rowData based on search query
    const filtered = rowData.filter((row) =>
      Object.values(row).some(
        (value) =>
          value &&
          value
            .toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase())
      )
    );
    setFilteredData(filtered);
  }, [searchQuery, rowData]);

  const updatedColDefs =
    onEdit ||
    onView ||
    onDelete ||
    onStatusChange ||
    onEnable ||
    onMcqView ||
    onDoubt ||
    onResult ||
    onDuplicate
      ? [
          ...colDefs,
          {
            headerName: "Actions",
            field: "action",
            width: 340,
            cellRenderer: (params) => (
              <>
                <div className="navbar-nav flex-row align-items-center ms-auto">
                  {onEdit && (
                    <button
                      type="button"
                      title="Edit"
                      style={{ height: "30px", width: "30px" }}
                      className="btn btn-icon btn-info m-2 mb-1"
                      onClick={() => {
                        console.log(params);
                        onEdit(params.data.idNumber);
                      }}
                    >
                      <span className="tf-icons mdi mdi-pencil"></span>
                    </button>
                  )}
                  {onView && (
                    <button
                      type="button"
                      title="View"
                      style={{ height: "30px", width: "30px" }}
                      className="btn btn-icon btn-primary m-2 mb-1"
                      onClick={() => {
                        showWithTwoPara
                          ? onView(params.data.idNumber, params.data.student)
                          : onView(params.data.idNumber);
                      }}
                    >
                      <span className="tf-icons mdi mdi-eye"></span>
                    </button>
                  )}
                  {onDelete && (
                    <button
                      type="button"
                      title="Delete"
                      style={{ height: "30px", width: "30px" }}
                      className="btn btn-icon btn-danger m-2 mb-1"
                      onClick={() => {
                        onDelete(params.data.idNumber, params.rowIndex);
                      }}
                    >
                      <span className="tf-icons mdi mdi-delete"></span>
                    </button>
                  )}
                  {onExport && (
                    <a
                      
                      title="Export"
                      style={{ height: "30px", width: "30px" }}
                      className="btn btn-icon btn-primary m-2 mb-1"
                      // onClick={() => {
                      //   onExport(params.data.idNumber);
                        
                      // }}
                      href={`${config.host_url}/mcqbanks/export?mbid=${params.data.idNumber}`} target="_blank"
                    >
                      <i className="fa-solid fa-file-export text-white"></i>
                    </a>
                  )}
                  {onMcqView && (
                    <div>
                      <button
                        type="button"
                        title="View MCQs"
                        style={{ height: "30px", width: "30px" }}
                        className="rounded btn-icon bg-[#f4a484]  text-white m-2 mb-1"
                        onClick={() => {
                          onMcqView(
                            params.data.idNumber,
                            params.data.course
                              ? params.data.course
                              : params.data.chapter
                          );
                        }}
                      >
                        <i className="mdi mdi-help-box-multiple"></i>
                      </button>
                    </div>
                  )}
                  {onDoubt && (
                    <div>
                      <button
                        type="button"
                        title="View Doubt"
                        style={{ height: "30px", width: "30px" }}
                        className="rounded btn-icon bg-[#6054a8] text-white m-2 mb-1"
                        onClick={() => {
                          const encodedId = window.btoa(
                            encodeURIComponent(params.data.idNumber)
                          );
                          navigate(`/viewdoubts/${encodedId}`);
                        }}
                      >
                        <i className="mdi mdi-comment-question-outline"></i>
                      </button>
                    </div>
                  )}
                  {onResult && (
                    <button
                      type="button"
                      title="View Result"
                      style={{ height: "30px", width: "30px" }}
                      className="rounded btn-icon bg-green-500 text-white m-2 mb-1"
                      onClick={() => {
                        console.log(params);
                        onResult(
                          params.data.idNumber,
                          resultOf === "chapter"
                            ? params.data.chapter
                            : resultOf === "course"
                            ? params.data.course
                            : ""
                        );
                      }}
                    >
                      <span className="tf-icons mdi mdi-clipboard-check"></span>
                    </button>
                  )}
                  {onDuplicate && (
                    <button
                      type="button"
                      title="Duplicate"
                      style={{ height: "30px", width: "30px" }}
                      className="rounded btn-icon bg-blue-500 text-white m-2 mb-1"
                      onClick={() => {
                        onDuplicate(params.data.idNumber);
                      }}
                    >
                      <span className="tf-icons mdi mdi-content-copy"></span>
                    </button>
                  )}
                </div>

                <div className="mt-0">
                  {onStatusChange && (
                    <select
                      className="form-select"
                      name="Status"
                      id="Status"
                      aria-label="Select Status"
                      value={params.data.status}
                      onChange={(e) =>
                        onStatusChange(e, params.data.idNumber, params.rowIndex)
                      }
                    >
                      <option value="" disabled selected>
                        --- Select Status ---
                      </option>
                      <option value="not_connected">Not Connected</option>
                      <option value="Demo_completed">Demo Completed</option>
                      <option value="Invoice_generated">
                        Invoice Generated
                      </option>
                    </select>
                  )}
                  {onEnable &&
                    ((params.data.admin_status === 0 &&
                      user_type === "admin") ||
                      (params.data.teacher_status === 0 &&
                        params.data.admin_status === 1 &&
                        user_type === "teacher") ||
                      (params.data.teacher_status === 0 &&
                        params.data.admin_status === 1 &&
                        user_type === "TPT")) && (
                      <button
                        type="button"
                        className="btn btn-info ml-2 btn-sm w-40   "
                        onClick={() => {
                          onEnable(params.data.idNumber, params.rowIndex);
                        }}
                      >
                        Approve
                      </button>
                    )}
                </div>
              </>
            ),
          },
        ]
      : [...colDefs];

  const gridOptions = {
    pagination,
    paginationPageSize,
    paginationPageSizeSelector,
    rowHeight: onStatusChange || onEnable ? 100 : 55,
    suppressHorizontalScroll: true,
    autoSizeColumns: true,
    autoSizeColsMode: "firstColumn",
    autoSizePadding: 20,
  };

  //-----------------for chapter multiple delete/ restore only----------------
  const onSelectionChanged = (event) => {
    const selectedNodes = event.api.getSelectedNodes();
    const selectedIds = selectedNodes.map((node) => node.data.idNumber);
    setList(selectedIds);
    setIsBtnEnabled(selectedIds.length > 0);
  };
  // --Delete selected chapters --D
  const showConfirmation = (action) => {
    // Check if tableTitle matches specific values
    const isDraftView = tableTitle === "View Courses - Draft" || tableTitle === "View Chapters - Draft";
  
    // If tableTitle is one of the draft views
    if (isDraftView) {
      const formattedAction = action[0].toUpperCase() + action.slice(1); // Capitalize action
      const confirmButtonText = `Yes, ${formattedAction} them!`;
  
      Swal.fire({
        title: "Are you sure?",
        text: `You are about to ${formattedAction} ${btnTxtFor}. Are you sure you want to proceed?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: confirmButtonText,
      }).then((result) => {
        if (result.isConfirmed) {
          handleAction(action); // Pass the specific action to handleAction
        }
      });
    } else {
      Swal.fire({
        title: "Are you sure?",
        text: `You are about to ${btnTxtAction + " " + btnTxtFor}. Are you sure you want to proceed?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: `Yes, ${btnTxtAction[0].toUpperCase() + btnTxtAction.slice(1)} them!`,
      }).then((result) => {
        if (result.isConfirmed) {
          handleAction(); // Call handleAction without action argument
        }
      });
    }
  };
  
  const handleAction = async () => {
    try {
      await fetch(`${config.host_url}${actionUrl}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
        body: JSON.stringify({ id: list }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(async function (data) {
          if (data.status === 200) {
            triggerNotification(
              "success",
              `${btnTxtFor} ${btnTxtAction}d successfully `
            );
            setList([]);
            setIsBtnEnabled(false);
            fetchDataAfterAction();
          } else if (data.status === 404) {
            console.error(`${btnTxtFor} IDs not found`);
            triggerNotification("error", `${btnTxtFor} IDs not found`);
          } else if (data.status === 401) {
            console.error("Invalid token");
            triggerNotification("error", "Unauthenticated User");
          } else {
            console.error("Internal server error");
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        });
    } catch (error) {
      console.error(`Error performing action on ${btnTxtFor}:`, error);
      triggerNotification("error", `Error performing action on ${btnTxtFor}`);
    }
  };
  //------------------------------------------------------------------

  return (
    <>
      {/* //-----------------for chapter multiple delete/ restore only---------------- */}
      {tableTitle && (
        <div
  className={`ml-0 d-flex align-items-center flex justify-between ${
    tableTitle === "View Courses - Draft" ? "py-0" : "py-[20px] "
  }`}
>
{(tableTitle !== "View Chapters" && tableTitle !== "View Courses" && tableTitle !== "View Teachers" && tableTitle !== "View Students") && (
  <h5 className={`${tableTitle === "View Courses - Draft" ? "pb-3" : "pb-2"}`}>
    {tableTitle}
  </h5>
)}


          <div className="w-42 flex space-x-4">
  {isBtnEnabled &&
        btnTxtAction.map((action, index) => (
          // Check if the tableTitle is NOT "View Chapters" before rendering delete button
          (action !== "delete" || (tableTitle !== "View Chapters" && tableTitle !== "View Courses")) && (
            <div
              key={index}
              className={
                action === "publish"
                  ? `text-blue-700 hover:text-white border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-blue-600 dark:focus:ring-blue-900`
                  : action === "delete"
                  ? `text-red-700 hover:text-white border border-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900`
                  : action === "restore"
                  ? "text-green-700 hover:text-white border border-green-700 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:border-green-500 dark:text-green-500 dark:hover:text-white dark:hover:bg-green-600 dark:focus:ring-green-900"
                  : ""
              }
              onClick={() => showConfirmation(action)} // Pass the specific action
            >
              {action[0].toUpperCase() + action.slice(1) + " " + btnTxtFor[0].toUpperCase() + btnTxtFor.slice(1)}
            </div>
          )
        ))}
</div>

        </div>
      )}
      {/* //------------------------------------------------------------------ */}
      <div
        className="ag-theme-quartz"
        style={{ height: fromDraft ? 748 : 374 }}
      >
      {/* Search Input */}
      
    {(tableTitle === "View Teachers" || tableTitle === "View Students") && 
      <input
      type="text"
      className="form-control"
      placeholder="Search..."
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      style={{ width: "250px", margin: "-20px 0 10px 0" }}
    />
        }
      {(tableTitle === "View Chapters" || tableTitle === "View Courses") && (
  <div className="flex justify-between items-center mb-3">
    {/* Search Input */}
    <input
      type="text"
      className="form-control"
      placeholder="Search..."
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      style={{ width: "250px" }}
    />

    {/* Delete Button */}
    <div className="w-42 flex space-x-4">
      {isBtnEnabled &&
        btnTxtAction.map((action, index) => (
          <div
            key={index}
            className={
              action === "delete"
                ? `text-red-700 hover:text-white border border-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900`
                : ""
            }
            onClick={() => showConfirmation(action)} // Pass the specific action
          >
            {action[0].toUpperCase() + action.slice(1) + " " + btnTxtFor[0].toUpperCase() + btnTxtFor.slice(1)}
          </div>
        ))}
    </div>
  </div>
)}
        <AgGridReact
          rowData={filteredData}
          columnDefs={updatedColDefs}
          onRowClicked={onRowClicked}
          gridOptions={gridOptions}
          getRowNodeId={(data) => data.idNumber}
          rowSelection={"multiple"}
          {...(fetchDataAfterAction
            ? { onSelectionChanged: onSelectionChanged }
            : {})}
        />
      </div>
    </>
  );
};

export default TableViewer;
